import React  from "react";
import JobRoleRequestTable from "./components/JobRoleRequestTable";
import { connect } from "react-redux";

const JobRoleRequests = () => {
	
	return (
	    <div>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">      		
				<JobRoleRequestTable />
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleRequests);